export const ICP_RECORD_LINK = 'https://beian.miit.gov.cn';
export const PUBLIC_SECURITY_RECORD_LINK = 'https://beian.mps.gov.cn/#/query/webSearch';
export const PUBLIC_SECURITY_RECORD_TEXT = '粤公网安备44040202001822号';

const DEFAULT_ICP_RECORD = '粤ICP备2025487635号-1';
const CN_DOMAIN_ICP_RECORD = '粤ICP备2025487635号-2';

function normalizeHost(rawHost = '') {
  return rawHost.trim().toLowerCase().split(':')[0];
}

export function getIcpRecordByHost(rawHost = '') {
  const domain = normalizeHost(rawHost);
  if (!domain) {
    return DEFAULT_ICP_RECORD;
  }

  if (domain === 'oltranslation.cn') {
    return CN_DOMAIN_ICP_RECORD;
  }

  if (domain === 'oltranslation.com' || domain.endsWith('.oltranslation.com')) {
    return DEFAULT_ICP_RECORD;
  }

  return DEFAULT_ICP_RECORD;
}
